import React, { useState } from "react";
import { Grid, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    borderTop: "1px solid #bbbbbb",
  },
});

export default function User({
  userId,
  firstName,
  lastName,
  role,
  handleRoleChange,
  removeUser,
  email,
  curUserRole,
}) {
  const curUser = curUserRole;
  const [user, setUser] = useState({
    id: userId,
    firstName: firstName,
    lastName: lastName,
    role: role,
    email: email,
  });
  const [editMode, toggleEditMode] = useState(false);
  const styles = useStyles();

  const canEditUser = (userRole) => {
    var result = false;

    if ((curUser === 'SA') || (curUser === 'Admin' && userRole !== 'SA')) {
      result = true;
    } 

    return  result;
  }

  const setEditMode = () => {
    if (editMode && role === user.role) {
      toggleEditMode(!editMode);
    } else if (editMode) {
      handleRoleChange(email, user.role);
      toggleEditMode(!editMode);
    } else {
      toggleEditMode(!editMode);
    }
  };
  return (
    <Grid
      container
      item
      xs={12}
      direction={{ xs: "column", sm: "row" }}
      pt={2}
      mb={2}
      justifyContent="center"
      alignItems="center"
      className={styles.root}
    >
      <Grid
        container
        item
        direction="column"
        xs={4}
        sm={3}
        alignItems="center"
        my={2}
      >
        <Grid item>Name:</Grid>
        <Grid item>
          {user.firstName} {user.lastName}
        </Grid>
      </Grid>
      <Grid
        container
        item
        direction="column"
        xs={4}
        sm={3}
        alignItems="center"
        my={2}
      >
        <Grid item>Email:</Grid>
        <Grid item textOverflow="ellipsis">
          {email}
        </Grid>
      </Grid>
      <Grid
        container
        item
        direction="column"
        xs={4}
        sm={3}
        alignItems="center"
        my={2}
      >
        <Grid item>Role:</Grid>
        <Grid item>
          {editMode ? (
            <select
              value={user.role}
              onChange={(e) => setUser({ ...user, role: e.target.value })}
            >
              <option value="Admin">Admin</option>

              <option value="Support">Support</option>
            </select>
          ) : (
            <>{user.role}</>
          )}
        </Grid>
      </Grid>
      <Grid container item xs={12} sm={3} justifyContent="center">
        <Grid item>
          {canEditUser(user.role) ? (
            <Button
              variant="contained"
              color="secondary"
              sx={{ marginRight: 1 }}
              onClick={() => setEditMode()}
            >
              Edit
            </Button>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item>
        {canEditUser(user.role) ? (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => removeUser(user)}
          >
            Delete
          </Button>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
